import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Snackbar,
  Grid,
  Paper,
  CircularProgress,
  IconButton,
} from "@mui/material";
import { Column } from "primereact/column";
import Tables from "./widgets/tables";
import DownloadTable from "./widgets/downloaddata";
import {
  GetRefreshBalance,
  UpdateBalance,
} from "../redux/slices/UpdateBalance";
import { useDispatch, useSelector } from "react-redux";
import RefreshIcon from "@mui/icons-material/Refresh";
import { keyframes } from "@emotion/react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DownloadData from "./widgets/downloaddata";
import ButtonTabs from "../components/widgets/buttontabs";
import moment from "moment";
import DoneIcon from "@mui/icons-material/Done";
import CancelIcon from "@mui/icons-material/Cancel";
import { CloseSuccess, TransactionPicture } from "../redux/slices/transpicture";
import { toast } from "react-toastify";

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const GameUpdateBalance = () => {
  const dispatch = useDispatch();
  const balance = useSelector((state) => state.refreshBalance);
  const loading = useSelector((state) => state.refreshBalance.loading);
  const [loadingIndex, setLoadingIndex] = useState(false);

  useEffect(() => {
    dispatch(GetRefreshBalance());
  }, []);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [selectedGame, setSelectedGame] = useState(null);
  const [newBalance, setNewBalance] = useState("");
  const [winningAmount, setWinningAmount] = useState("");
  const [allobject, setObject] = useState([]);
  const userData = useSelector((state) => state.login.user);
  const [error, setError] = useState("");
  const pic = useSelector((val) => val.transpic);
  const handleUpdateBalance = (data, index) => {
    setLoadingIndex(index);
    setSelectedGame(true);
    dispatch(CloseSuccess());
    setObject(data);
  };

  const headers = [
    "SrNo",
    "User Name",
    "Game Name",
    "Game id",
    "Balance",
    "Date",
    "Status",
  ];

  const tableData = balance?.data?.map((row, index) => [
    index + 1,
    row.name || "N/A",
    row.game || "N/A",
    row.gameid || "N/A",
    row.balance || "N/A",
    moment(row?.createdAt).format("L"),
    row.status || "N/A",
  ]);

  const handleConfirmUpdate = async () => {
    const balanceValue = parseFloat(newBalance);
    if (isNaN(balanceValue) || balanceValue < 0) {
      setError("Please enter a valid positive number for the balance.");
      return;
    }
    if (!pic?.data) {
      toast.error("Please add Attachment!");
    }
    if (pic?.data) {
      const payload = {
        uid: userData?.id,
        uname: userData?.name,
        gameid: allobject?.gameid,
        ghid: allobject?._id,
        amount: newBalance,
        image: pic?.data,
        winning: winningAmount,
      };
      dispatch(UpdateBalance(payload));

      setOpenSnackbar(true);
      setSelectedGame(null);
      setNewBalance("");
      setWinningAmount("");
      setError("");
    }
  };

  const actionBodyTemplate = (rowData, index) => {
    if (rowData?.matched) {
      return (
        <span className="text-orange-600">
          Redeem request already pending for this user.
        </span>
      );
    } else if (rowData?.bl?.includes(7)) {
      return (
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleUpdateBalance(rowData, index)}
          disabled={index === loadingIndex}
        >
          {index === loadingIndex ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            "Update Balance"
          )}
        </Button>
      );
    }
  };

  const statusBodyTemplate = (rowData) => {
    let color, icon, statusText;

    if (rowData?.bl?.includes(8)) {
      color = "#4CAF50";
      statusText = "Approved";

      icon = (
        <>
          <DoneIcon sx={{ color: "white", fontSize: "16px" }} />
        </>
      );
    } else {
      color = "#FFC104";
      statusText = "Pending";
      icon = (
        <>
          <DoneIcon sx={{ color: "white", fontSize: "16px" }} />
        </>
      );
    }

    return (
      <div className="flex justify-start items-center">
        <Box
          className="mr-2"
          sx={{
            width: 24,
            height: 24,
            borderRadius: "50%",
            backgroundColor: color,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {icon}{" "}
        </Box>

        {rowData?.bl?.includes(8) ? "Done" : "Pending"}
      </div>
    );
  };

  const handleRefreshBalance = () => {
    dispatch(GetRefreshBalance());
  };
  const updateTransPic = (event) => {
    const file = event.target.files[0];
    if (file) {
      dispatch(TransactionPicture(file));
    }
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          my: 4,
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Typography variant="h5">Update Balance Requests</Typography>
          <IconButton
            onClick={() => handleRefreshBalance()}
            disabled={loading}
            sx={{
              animation: loading ? `${rotate} 1s linear infinite` : "none",
              backgroundColor: "#3f51b5",
              color: "white",
              "&:hover": {
                backgroundColor: "#303f9f",
              },
              "&:disabled": {
                backgroundColor: "#e0e0e0",
              },
            }}
          >
            <RefreshIcon />
          </IconButton>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <DownloadData
            headers={headers || []}
            tableData={tableData || []}
            fileName={"Update-balance-Requests"}
          />
        </Box>
      </Box>
      {/* <Box>
        <ButtonTabs />
      </Box> */}
      <Tables rowData={balance?.data}>
        <Column
          field="no"
          header="#"
          body={(rowData, options) => options.rowIndex + 1}
          filter
          filterPlaceholder="Search by #"
        />
        <Column
          field="name"
          header="User Name"
          filter
          filterPlaceholder="Search by User Name"
          body={(rowData) => `${rowData?.name}`}
        />
        <Column
          field={"game" || "N/A"}
          header="Game Name"
          filter
          filterPlaceholder="Search by Game Name"
        />
        <Column
          field="username"
          header="Game ID"
          filter
          filterPlaceholder="Search by Game ID"
          body={(rowData) => (
            <Box display="flex" alignItems="center" gap={1}>
              <Typography variant="body2">{rowData.username}</Typography>
              <ContentCopyIcon
                sx={{ cursor: "pointer", fontSize: 18, color: "#666" }}
                onClick={() => navigator.clipboard.writeText(rowData.username)}
              />
            </Box>
          )}
        />

        {/* <Column
          field="createdAt"
          header="Game Before Balance"
          filter
          body={(rowData) => `$${rowData?.amount}/01` || "N/A"}
          filterPlaceholder="Search by Date"
        /> */}
        <Column
          field="balance"
          header="Wallet Balance"
          filter
          filterPlaceholder="Search by Balance"
          body={(rowData) => `$${rowData?.balance}` || "N/A"}
        />
        <Column
          field="balance"
          header="Game Balance"
          filter
          filterPlaceholder="Search by Balance"
          body={(rowData) =>
            `$${rowData?.amount}/$${rowData?.winsamount}` || "N/A"
          }
        />
        {/* <Column
          field="createdAt"
          header="Game After Balance"
          filter
          body={(rowData) => `$${rowData?.balance}/01` || "N/A"}
          filterPlaceholder="Search by Date"
        /> */}
        {/* <Column
          field="createdAt"
          header="Date"
          filter
          body={(rowData) => moment(rowData?.createdAt).format("L LT")}
          filterPlaceholder="Search by Date"
        /> */}
        <Column
          field="createdAt"
          header="Date"
          filter
          body={(rowData) => moment(rowData?.createdAt).format("L LT")}
          filterPlaceholder="Search by Date"
        />
        <Column
          field="image"
          header="Attachment"
          filter
          filterPlaceholder=""
          body={(rowData) =>
            rowData?.image && (
              <img
                className="w-10 h-10 rounded-full object-cover"
                src={rowData?.image}
                alt="img"
              />
            )
          }
        />
        <Column
          field="status"
          header="Status"
          filter
          body={statusBodyTemplate}
          filterPlaceholder="Search by Status"
        />
        <Column body={actionBodyTemplate} header="Actions" />
      </Tables>

      <Dialog
        open={!!selectedGame}
        onClose={() => setSelectedGame(null)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Update Balance for {allobject?.game}</DialogTitle>
        <DialogContent>
          <Paper elevation={3} sx={{ padding: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label="Curr Game Balance"
                  value={`$${allobject?.amount}`}
                  fullWidth
                  disabled
                  sx={{ borderRadius: "8px", marginBottom: 2 }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Curr Wins Amount"
                  value={`$${allobject?.winsamount}`}
                  fullWidth
                  disabled
                  sx={{ borderRadius: "8px", marginBottom: 2 }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  autoFocus
                  margin="dense"
                  label="Balance"
                  type="number"
                  fullWidth
                  value={newBalance}
                  onChange={(e) => setNewBalance(e.target.value)}
                  error={!!error}
                  helperText={error}
                  sx={{ borderRadius: "8px" }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  autoFocus
                  margin="dense"
                  label="Winning amount"
                  type="number"
                  fullWidth
                  value={winningAmount}
                  onChange={(e) => setWinningAmount(e.target.value)}
                  error={!!error}
                  helperText={error}
                  sx={{ borderRadius: "8px" }}
                />
              </Grid>
              {/* <Grid item xs={12}>
                <Button variant="outlined" component="label" fullWidth>
                  Upload Attachment
                  <input type="file" hidden onChange={handleFileChange} />
                </Button>
                {file && <div style={{ marginTop: 8 }}>{file.name}</div>}
              </Grid> */}
              <div className="">
                <h5 className="text-black">Upload Screenshot:</h5>
                {pic?.data?.length > 0 && (
                  <img
                    src={allobject?.image ? allobject?.image : pic?.data}
                    alt="img here"
                  />
                )}
                <label className="block text-black justify-center items-center  mt-2">
                  {allobject?.image ? (
                    ""
                  ) : pic?.loading ? (
                    <div
                      className="spinner-border text-[#e2008a] rounded-full"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  ) : (
                    <>
                      <input
                        type="file"
                        accept="image/*"
                        onChange={updateTransPic}
                        className="border-2 rounded-md p-[8px] outline-none w-full text-black"
                      />
                    </>
                  )}
                </label>
              </div>
            </Grid>
          </Paper>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSelectedGame(null)}>Cancel</Button>
          <Button
            onClick={handleConfirmUpdate}
            color="primary"
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Update"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        message="Balance updated successfully!"
        onClose={() => setOpenSnackbar(false)}
      />
    </>
  );
};

export default GameUpdateBalance;
